import { combineReducers } from 'redux';
import activity from './activity';
import adminNotifications from './adminNotifications';
import auth from './auth';
import bulletins from './bulletins';
import bulletinTags from './bulletinTags';
import crs from './CR';
import endUserAddresses from './endUserAddresses';
import endUsers from './endUsers';
import endUserSerialNumbers from './endUserSerialNumbers';
import entities from './entities';
import folders from './folders';
import formReducer from './form';
import groups from './groups';
import groupsByType from './groupsByType';
import oems from './oems';
import pageFiles from './pageFiles';
import pages from './pages';
import password from './password';
import PICategories from './PICategories';
import PISheets from './PISheets';
import products from './products';
import qsrCategories from './QSRCategories';
import qsrManufacturers from './QSRManufacturers';
import qsrProductTypes from './QSRProductTypes';
import qsrs from './QSR';
import qsrTypes from './QSRTypes';
import search from './search';
import sidebar from './sidebar';
import sourcesafeEntries from './sourcesafeEntries';
import users from './users';
import usersByGroup from './usersByGroup';

const rootReducer = combineReducers({
	activity,
	adminNotifications,
	auth,
	bulletins,
	bulletinTags,
	crs,
	endUserAddresses,
	endUsers,
	endUserSerialNumbers,
	entities,
	folders,
	form: formReducer,
	groups,
	groupsByType,
	oems,
	pageFiles,
	pages,
	password,
	PICategories,
	PISheets,
	products,
	qsrCategories,
	qsrManufacturers,
	qsrProductTypes,
	qsrs,
	qsrTypes,
	search,
	sidebar,
	sourcesafeEntries,
	users,
	usersByGroup,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js